export default __webpack_public_path__ + "static/media/box1.418bed4e.jpg";